import React from 'react';
import { Scale } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function CostComparison() {
  const comparisons = [{
    without: 'Grúa por una falla que se resolvía solo',
    cost: '$25.000 – $45.000 ARS por llamada'
  }, {
    without: 'Diagnóstico de taller sin saber describir la falla',
    cost: '$15.000 – $30.000 ARS extra'
  }, {
    without: 'Noche en la banquina o en una ciudad desconocida',
    cost: 'Tu tiempo y tu tranquilidad'
  }, {
    without: 'Salir sin checklist y que falle algo previsible',
    cost: 'Riesgo real en cada salida'
  }, {
    without: 'No saber si parar o seguir con un ruido nuevo',
    cost: 'Una moto destruida por seguir cuando no debías'
  }];
  return <section className="py-24 relative" data-id="element-34">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-35">
        <FadeIn data-id="element-36">
          <div className="text-center mb-16" data-id="element-37">
            <Scale className="w-12 h-12 text-gray-500 mx-auto mb-6" data-id="element-38" />
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-39">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-40">
          <div className="bg-surface rounded-2xl border border-white/5 overflow-hidden mb-6" data-id="element-41">
            <div className="grid grid-cols-2 bg-surfaceLight p-4 md:p-6 border-b border-white/5" data-id="element-42">
              <div className="font-bold text-gray-400 uppercase tracking-wider text-sm md:text-base" data-id="element-43">
                Sin Protocolo Anti-Tirado
              </div>
              <div className="font-bold text-red-400 uppercase tracking-wider text-sm md:text-base pl-4 md:pl-6 border-l border-white/5" data-id="element-44">
                Costo real
              </div>
            </div>

            <div className="divide-y divide-white/5" data-id="element-45">
              {comparisons.map((item, i) => <div key={i} className="grid grid-cols-2 p-4 md:p-6 hover:bg-white/[0.02] transition-colors" data-id="element-46">
                  <div className="text-gray-300 pr-4" data-id="element-47">{item.without}</div>
                  <div className="text-red-300/80 pl-4 md:pl-6 border-l border-white/5 font-medium" data-id="element-48">
                    {item.cost}
                  </div>
                </div>)}
              <div className="grid grid-cols-2 p-4 md:p-6 bg-red-500/5" data-id="element-49">
                <div className="text-white font-bold pr-4" data-id="element-50">
                  Total estimado de pérdidas evitables por año
                </div>
                <div className="text-red-400 font-bold pl-4 md:pl-6 border-l border-white/5" data-id="element-51">
                  $100.000 – $200.000 ARS
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-52">
          <div className="mt-16 text-center max-w-3xl mx-auto" data-id="element-53">
            <p className="text-xl md:text-2xl text-gray-300 italic mb-6" data-id="element-54">
              🏍️ "La próxima vez que tu moto falle en la calle, hay dos
              versiones de vos."
            </p>
            <div className="space-y-4 text-left bg-surfaceLight/30 p-6 rounded-2xl border border-white/5" data-id="element-55">
              <p className="text-gray-400" data-id="element-56">
                <span className="text-red-400 font-bold" data-id="element-57">Versión 1:</span> El
                que para en la banquina sin saber qué hacer, llama a alguien sin
                poder describir la falla y espera la grúa 2 horas.
              </p>
              <p className="text-gray-300" data-id="element-58">
                <span className="text-cyan font-bold" data-id="element-59">Versión 2:</span> El que
                para en la banquina, abre el protocolo, sigue los 15 pasos y en
                15 minutos sabe exactamente qué tiene la moto, cómo resolverlo o
                cómo comunicárselo al mecánico.
              </p>
            </div>
            <p className="text-cyan font-bold mt-6 text-lg" data-id="element-60">
              La diferencia entre las dos versiones es este sistema.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}